import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CategoryService } from "src/app/services/category.service";
import { EntityService } from "src/app/services/entity.service";
import { ReportService } from "src/app/services/report.service";
import { SharedService } from "src/app/services/sharedService";
import { YearService } from "src/app/services/year.service";
import { MultiselectAutocompleteComponent } from "../../multiselect-autocomplete/multiselect-autocomplete.component";
import { UserService } from "src/app/services/user.service";
import { RevenueCodeService } from "src/app/services/revenueCode.service";
@Component({
  selector: "app-statistics-search",
  templateUrl: "./search-statistics.component.html",
  styleUrls: ["./search-statistics.component.css"],
})
export class SearchStatisticsComponent implements OnInit, OnDestroy {
  @ViewChild('categorySelect', { static: false }) categorySelect: MultiselectAutocompleteComponent;
  @ViewChild('municipalitySelect', { static: false }) municipalitySelect: MultiselectAutocompleteComponent;
  @ViewChild('revenueCodeSelect', { static: false }) revenueCodeSelect: MultiselectAutocompleteComponent;
  @ViewChild('formTypeSelect', { static: false }) formTypeSelect: MultiselectAutocompleteComponent;
  @ViewChild('statusSelect', { static: false }) statusSelect: MultiselectAutocompleteComponent;
  @ViewChild('yearSelect', { static: false }) yearSelect: MultiselectAutocompleteComponent;
  @ViewChild('userSelect', { static: false }) userSelect: MultiselectAutocompleteComponent;
  @ViewChild('districtSelect', { static: false }) districtSelect: MultiselectAutocompleteComponent;
  @ViewChild('streetSelect', { static: false }) streetSelect: MultiselectAutocompleteComponent;
  searchDateFrom = new Date();
  searchDateTo = new Date();  
  municipalityChangeSubscription: any;
  @Input() internal;
  statuses: any
  rec_statuses: any
  years: any
  month: any;
  months = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
  ];
  filterData = {
    category: null,
    municipality: null,
    report: null,
    formTypes: null,
    district: null,
    street: null
  };
  allMunicipalities = [];
  allDistricts = [];
  allReports = [];
  @Output() onFilter = new EventEmitter<any>();
  @Output() onReset = new EventEmitter<any>();
  @Input() extraFields: any;
  queryFilter = {};
  filterFields = ["municipality"];
  panelOpenState = true;
  constructor(public categoryService: CategoryService, public entityService: EntityService, public sharedService: SharedService,
    public reportService: ReportService, public yearService: YearService, public translate: TranslateService, public userService: UserService,
    public revenueCodeService: RevenueCodeService
  ) {

 
  }
  objectComparisonFunctionId = function (option, value): boolean {
    let sss = value ? option.key === value.key : false
    return sss;
  };
  selectChange = (event: any, field) => {
    this.queryFilter[field] = event.data.map(elem => elem.id);
  
    if (this.queryFilter[field].length === 0) {
      delete this.queryFilter[field];
    }
  
    if (field === 'municipality' && this.extraFields?.allSubmittedDec) {
      this.handleMunicipalityChange(event.data);
    }
  
    if (field === 'district' && this.extraFields?.allSubmittedDec) {
      this.handleDistrictChange(event.data);
    }
    if (field === 'year' && this.extraFields?.allSubmittedDec) {
      this.handleYearChange(event.data);
    }
  };

  handleYearChange(selectedYears) {
    delete this.queryFilter['formTypes'];
  
    if (this.formTypeSelect) this.formTypeSelect.resetAll();
  
    this.setFormTypesFromReports(selectedYears);
  }

  handleMunicipalityChange(selectedMunicipalities) {
    this.filterData['district'] = [];
    this.filterData['street'] = [];
  
    delete this.queryFilter['district'];
    delete this.queryFilter['street'];
  
    if (this.districtSelect) this.districtSelect.resetAll();
    if (this.streetSelect) this.streetSelect.resetAll();
  
    selectedMunicipalities.forEach(municipality => {
      if (municipality.district && municipality.district.length > 0) {
        municipality.district.forEach(dist => {
          const fullDistrict = this.allDistricts.find(d => d.id === dist.id);
  
          if (fullDistrict) {
            this.filterData['district'].push(fullDistrict);
          } else {
            this.filterData['district'].push(dist);
          }
        });
      }
    });
  
    this.filterData['district'] = [...this.filterData['district'].reduce((map, obj) => {
      map.set(obj.id, obj);
      return map;
    }, new Map()).values()];
  
    this.filterData['district'].sort((a, b) => a.name.localeCompare(b.name));
  }

  handleDistrictChange(selectedDistricts) {
    this.filterData['street'] = [];
  
    delete this.queryFilter['street'];
  
    if (this.streetSelect) this.streetSelect.resetAll();
  
    selectedDistricts.forEach(district => {
      if (district.street && district.street.length > 0) {
        this.filterData['street'] = [
          ...this.filterData['street'],
          ...district.street
        ];
      }
    });
  
    this.filterData['street'] = [...this.filterData['street'].reduce((map, obj) => {
      map.set(obj.id, obj);
      return map;
    }, new Map()).values()];
  
    this.filterData['street'].sort((a, b) => a.name.localeCompare(b.name));
  }

  ngOnDestroy(): void {
    if (this.municipalityChangeSubscription) this.municipalityChangeSubscription.unsubscribe()
  }
  resetFilter() {
    this.queryFilter = {};
  
    if (this.municipalitySelect) this.municipalitySelect.resetAll();
    if (this.revenueCodeSelect) this.revenueCodeSelect.resetAll();
    if (this.formTypeSelect) this.formTypeSelect.resetAll();
    if (this.statusSelect) this.statusSelect.resetAll();
    if (this.yearSelect) this.yearSelect.resetAll();
    if (this.userSelect) this.userSelect.resetAll();
    if (this.districtSelect) this.districtSelect.resetAll();
    if (this.streetSelect) this.streetSelect.resetAll();
  
    this.month = null;
  
    if (this.extraFields?.userDecActivity && !this.extraFields?.allSubmittedDec) {
      this.searchDateFrom = new Date();
      this.searchDateTo = new Date();
      this.searchDateFrom.setHours(0, 0, 0, 0);
      this.searchDateTo.setHours(23, 59, 59, 999);
    } else {
      this.searchDateFrom = null;
      this.searchDateTo = null;
    }
  
    if (this.extraFields?.allSubmittedDec) {
      this.queryFilter['allSubmittedDec'] = true;
    }
  
    if (this.extraFields?.userDecActivity && !this.extraFields?.allSubmittedDec) {
      this.queryFilter['userDecActivity'] = true;
    }
    
    this.onReset.emit();
  }

  advancedSearch() {
    let selData = []
    selData = this.municipalitySelect.selectData.filter(el=> el.selected).map(el => el.item.id)
    if (localStorage.getItem('municipality')) {
      if (localStorage.getItem('municipality') == "-1") {
        delete this.queryFilter['municipality']
      } else {
        if (selData.length>0)
          this.queryFilter['municipality'] = selData
        else
        this.queryFilter['municipality'] = [localStorage.getItem('municipality')]
      }
    } else {
      if (this.municipalitySelect.selectData.length === 0)
        delete this.queryFilter['municipality']
    }
    if (this.searchDateTo) this.searchDateTo.setHours(23, 59, 59, 999);

    if (this.extraFields?.userDecActivity && !this.extraFields?.allSubmittedDec) {
      if (this.searchDateTo) this.searchDateTo.setHours(23, 59, 59, 999);
    
      !this.isEmpty(this.searchDateFrom) && (this.queryFilter['searchDateFrom'] = this.searchDateFrom);
      !this.isEmpty(this.searchDateTo) && (this.queryFilter['searchDateTo'] = this.searchDateTo);
    } else {
      delete this.queryFilter['searchDateFrom'];
      delete this.queryFilter['searchDateTo'];
    }

    if (this.extraFields?.userDecActivity) {
      this.queryFilter['userDecActivity'] = true;
    }
    if (this.extraFields?.allSubmittedDec) {
      this.queryFilter['allSubmittedDec'] = true;
    }
    this.onFilter.emit(this.queryFilter)
    this.panelOpenState = false
  }

  isEmpty(val) {
    return !val
  }

  selectMonth(event) {
    if (event.value) {
      this.queryFilter['month'] = event.value;
    } else {
      delete this.queryFilter['month'];
    }
  }

  ngOnInit() {
    this.searchDateFrom.setHours(0, 0, 0, 0);
    this.searchDateTo.setHours(23, 59, 59, 999);
  
    this.loadStatuses();
  
    if (this.extraFields?.allSubmittedDec) {
      this.loadAllSubmittedDecFilters();
      return;
    }
  
    if (this.extraFields?.userDecActivity) {
      this.loadUserDecActivityFilters();
      return;
    }
  
    this.loadNormalStatisticsFilters();
  }

  loadStatuses() {
    this.translate.get('DECLARATIONS.SUBMITTED').subscribe(() => {
      this.statuses = [
        { name: this.translate.instant("DECLARATIONS.SUBMITTED"), id: 'Submitted' },
        { name: this.translate.instant("DECLARATIONS.INPROGRESS"), id: 'In Progress (Draft)' },
        { name: this.translate.instant("DECLARATIONS.INPROGRESS_AUTO"), id: 'In Progress_auto' }
      ];
  
      this.rec_statuses = [
        { name: this.translate.instant("DECLARATIONS.ONGOING"), id: 'ONGOING' },
        { name: this.translate.instant("DECLARATIONS.SUSPENDED"), id: 'SUSPENDED' },
        { name: this.translate.instant("DECLARATIONS.REMOVED"), id: 'REMOVED' }
      ];
    });
  }

  loadAllSubmittedDecFilters() {
    this.filterData['district'] = [];
    this.filterData['street'] = [];
    this.filterData['formTypes'] = [];

    this.loadUsers();
    this.loadMunicipalities();
    this.loadAllDistricts();
    this.loadYears();
    this.loadReportsForFormTypes();
  }

  loadUserDecActivityFilters() {
    this.loadUsers();
    this.loadDictionaryFields();
  }

  loadNormalStatisticsFilters() {
    this.loadDictionaryFields();
    this.loadYears();
    this.loadReports();
  }

  loadUsers() {
    this.userService.getUsernames().subscribe(val => {
      this.filterData['users'] = val.map(user => ({
        id: user.username.trim(),
        name: user.username
      })).sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  loadReportsForFormTypes() {
    this.reportService.getReportsList("?active=true&internal=" + this.internal).subscribe(rep => {
      if (rep && rep.reports) {
        this.allReports = rep.reports;
        this.setFormTypesFromReports();
      }
    });
  }

  setFormTypesFromReports(selectedYears = []) {
    let reports = this.allReports || [];
  
    if (selectedYears && selectedYears.length > 0) {
      const yearIds = selectedYears.map(y => y.id);
      reports = reports.filter(report => yearIds.includes(report.year));
    }
  
    this.filterData['formTypes'] = reports
      .filter(report => report && report.revenueCode)
      .map(report => {
        if (Array.isArray(report.revenueCode) && report.revenueCode.length > 0) {
          return {
            id: report.revenueCode[0].id,
            code: report.revenueCode[0].code,
            name: `${report.revenueCode[0].code} - ${report.revenueCode[0].name}`
          };
        }
  
        return {
          id: report.revenueCode,
          code: report.revenueCode,
          name: report.name
        };
      })
      .filter(item => item && item.code);
  
    this.filterData['formTypes'] = [
      ...this.filterData['formTypes'].reduce((map, obj) => {
        map.set(obj.id || obj.code, obj);
        return map;
      }, new Map()).values()
    ];
  
    this.filterData['formTypes'].sort((a, b) => Number(a.code) - Number(b.code));
  }

  loadDictionaryFields() {
    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(() => {
      this.setSelectedMunicipality();
    });
  
    this.filterFields.forEach((field) => {
      this.categoryService.getList(field).subscribe((result) => {
        if (result) {
          this.filterData[field] = result.map((fld) => ({
            ...fld,
            name: fld.name,
            id: fld.id,
          }));
        }
  
        setTimeout(() => {
          this.setSelectedMunicipality();
        }, 1000);
      });
    });
  }

  setSelectedMunicipality() {
    if (!this.municipalitySelect || !this.filterData['municipality']) return;
  
    if (localStorage.getItem('municipality')) {
      if (localStorage.getItem('municipality') !== '-1') {
        this.municipalitySelect.resetAll();
        this.municipalitySelect.setSelectedData(
          this.filterData['municipality'].filter(elem => elem.id === localStorage.getItem('municipality'))
        );
      } else {
        this.municipalitySelect.resetAll();
      }
    } else {
      this.municipalitySelect.resetAll();
    }
  }

  isApplyDisabled() {
    if (!this.extraFields?.allSubmittedDec) {
      return false;
    }
  
    const hasMunicipality =
      this.queryFilter &&
      this.queryFilter['municipality'] &&
      this.queryFilter['municipality'].length > 0;
  
    const hasYear =
      this.queryFilter &&
      this.queryFilter['year'] &&
      this.queryFilter['year'].length > 0;
  
    return !(hasMunicipality && hasYear);
  }

  loadYears() {
    this.yearService.getList("year").subscribe(val => {
      this.years = val.map(elem => ({
        name: elem.year,
        id: elem.year
      }));
    });
  }

  loadMunicipalities() {
    this.categoryService.getList('municipality').subscribe((result) => {
      if (result) {
        this.filterData['municipality'] = result.map((fld) => ({
          ...fld,
          name: fld.name,
          id: fld.id,
        }));
      }
    });
  }
  
  loadAllDistricts() {
    this.categoryService.getList('district').subscribe((result) => {
      if (result) {
        this.allDistricts = result.map((fld) => ({
          ...fld,
          name: fld.name,
          id: fld.id,
        }));
      }
    });
  }

  loadReports() {
    this.reportService.getReportsList("?active=true&internal=" + this.internal).subscribe(rep => {
      if (rep && rep.reports) {
        this.filterData.report = rep.reports
          // An empty array is truthy, so a bare `elem.revenueCode` check let
          // reports with no revenue code through and `revenueCode[0].code`
          // threw. Same guard setFormTypesFromReports already uses.
          .filter(elem => Array.isArray(elem.revenueCode) && elem.revenueCode.length > 0)
          .map(elem => ({
            id: elem.revenueCode[0].code,
            name: elem.revenueCode[0].code
          }))
          .filter(elem => elem.id !== undefined);
  
        this.filterData.report.sort((a, b) => a.name.localeCompare(b.name));
  
        this.filterData.report = [...this.filterData.report.reduce((map, obj) => {
          map.set(obj.id, obj);
          return map;
        }, new Map()).values()];
      }
    });
  }
  
}
